<div class="h-100 w-100 d-flex flex-column flex-grow-1 overflow-auto">

    <div class="position-absolute w-100 d-flex" [class.justify-content-end]="isRTL">
        <button type="button" mat-icon-button aria-label="Toggle sidenav" (click)="closeProcessingFileDialog()"
            class="close-icon d-flex align-items-center justify-content-center" [class.text-white]="isDarkMode">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- CLOSED -->
    <div *ngIf="isClosed"
        class="d-flex flex-grow-1 flex-column align-items-center justify-content-center px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-3 w-100"
        [class.zx-text-white]="isDarkMode">

        <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0 text-green" [class.zx-ltr]="!isRTL"
            [class.text-white]="isDarkMode" [class.zx-ltr]="!isRTL">
            {{ "processing-file.by-by-1" | translate }}
        </h4>
        <button type="button" mat-raised-button class="edit-guide-btn-shimmer-bg text-white rounded-pill zx-btn-single w-100 fw-bold"
            (click)="goToEditInstructions()">
            {{ "q-and-a.2.btn-edit-guide" | translate }}
        </button>
    </div>

    <!-- OPEN -->
    <div *ngIf="!isClosed"
        class="d-flex flex-grow-1 flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-3 w-100"
        [class.zx-text-white]="isDarkMode">

        <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0 text-green" [class.zx-ltr]="!isRTL"
            [class.text-white]="isDarkMode" [class.zx-ltr]="!isRTL">
            <span *ngIf="fileType !== 'Unknown'">{{ "processing-file.pre-title.1" | translate }}</span>
            <span *ngIf="fileType !== 'Unknown'">{{ fileType }}</span>
            <span *ngIf="fileType !== 'Unknown' && isALotOfTime">{{ "processing-file.pre-title.2" | translate }}</span>
            <span *ngIf="fileType !== 'Unknown' && !isALotOfTime">{{ "processing-file.pre-title.3" | translate }}</span>
            <span *ngIf="fileType === 'Unknown'">{{ "processing-file.unknown-title" | translate }}</span>
        </h4>

        <div class="d-flex flex-column align-items-center w-100 flex-grow-1">

            <span class="d-flex flex-column gap-1 gap-lg-2 w-100" style="max-width: 495px;" [class.zx-ltr]="!isRTL">
                <b *ngIf="fileType !== 'Unknown'" class="text-green zx-text-medium zx-text-sm-big py-1 py-lg-2" [class.text-start]="!isRTL">
                    <span *ngIf="getVeryReducedFormat() !== 'PDF' && getVeryReducedFormat() !== 'JPEG'">
                        {{fileType}}
                    </span>
                    <span>
                        {{ "processing-file.title." + (getVeryReducedFormat() !== 'PDF' &&
                        getVeryReducedFormat() !== 'JPEG' ? "OTHER" :
                        getVeryReducedFormat()) | translate }}
                    </span>
                </b>
                <span *ngIf="fileType === 'PDF'" [class.text-start]="!isRTL">
                    {{ "processing-file.pdf.exp.1" | translate }}
                </span>
                <span *ngIf="fileType === 'PDF'" [class.text-start]="!isRTL">
                    {{ "processing-file.pdf.exp.2" | translate }}
                </span>
                <span *ngIf="fileType === 'JPEG'" [class.text-start]="!isRTL">
                    {{ "processing-file.jpeg.exp.1" | translate }}
                </span>
                <div class="d-flex zx-text-medium" [class.text-start]="!isRTL">
                    <ul *ngIf="fileType === 'PDF'" class="pt-2 mb-0" [class.text-start]="!isRTL">
                        <li class="pb-2">
                            {{ "processing-file.pdf.point-1" | translate }}
                        </li>
                        <li class="pb-2">
                            {{ "processing-file.pdf.point-2" | translate }}
                        </li>
                        <li class="pb-2 d-lg-none">
                            {{ "processing-file.pdf.point-3" | translate }}
                        </li>
                        <li class="d-lg-none">
                            {{ "processing-file.pdf.point-4" | translate }}
                        </li>
                    </ul>
                    <ul class="d-none d-lg-inline pt-2" *ngIf="fileType === 'PDF'" [class.text-start]="!isRTL">
                        <li class="pb-2">
                            {{ "processing-file.pdf.point-3" | translate }}
                        </li>
                        <li>
                            {{ "processing-file.pdf.point-4" | translate }}
                        </li>
                    </ul>
                </div>

            </span>

            <!-- מדריך לעריכת קבצים – כמו בשאלות נפוצות; בעברית צמוד לימין -->
            <div class="d-flex flex-column w-100" style="max-width: 495px;"
                [class.align-items-center]="!isRTL" [class.align-items-end]="isRTL" [class.zx-ltr]="!isRTL">
                <p *ngIf="getVeryReducedFormat() !== 'PDF'" class="mb-2 w-100" [class.text-end]="isRTL" [class.text-start]="!isRTL" [class.text-white]="isDarkMode">
                    {{ "processing-file.edit-instructions-note" | translate }}
                </p>
                <p class="q-and-a-edit-print-shimmer fw-bold mb-2 w-100 pt-2" [class.text-end]="isRTL" [class.text-start]="!isRTL">
                    {{ "q-and-a.2.content-2" | translate:{count: editGuideSoftwareKeys.length} }}
                </p>
                <div class="d-flex flex-wrap gap-2 justify-content-center w-100 mb-3">
                    <span *ngFor="let key of editGuideSoftwareKeys"
                          class="rounded-pill px-3 py-1 zx-text-small d-inline-block c-pointer"
                          [class.bg-white]="!isDarkMode"
                          [class.bg-dark]="isDarkMode"
                          [class.text-dark]="!isDarkMode"
                          [class.text-white]="isDarkMode"
                          style="border: 1px solid rgba(0,0,0,0.12);"
                          (click)="goToEditInstructions()">
                        <span class="q-and-a-edit-print-shimmer">{{ key | translate }}</span>
                    </span>
                </div>
                <p class="mb-3 w-100" [class.text-end]="isRTL" [class.text-start]="!isRTL" [class.text-white]="isDarkMode">
                    {{ "q-and-a.2.content-3" | translate }}
                </p>
                <button type="button" mat-raised-button class="edit-guide-btn-shimmer-bg text-white rounded-pill zx-btn-single w-100 fw-bold"
                    (click)="goToEditInstructions()">
                    {{ "q-and-a.2.btn-edit-guide" | translate }}
                </button>
            </div>

        </div>

    </div>
</div>